import React from 'react'
import Dashboard from '../sections/client/Dashboard'
import Partner from '../sections/client/Partner'
import Footer from '../layout/footer'
import Reviews from '../sections/review/Reviews'
import { Helmet } from 'react-helmet'

const Client = () => {
  return (
    <div id='page'>
            <Helmet>
        <title> Vwrap | Our Valuable Clients</title>
        <meta name="description" content="Take a look at the high-end companies that have partnered with Vwrap. If you’ve seen advertisements for these clients, then you know our quality of work!" />
      </Helmet>
      <Dashboard />
      <Partner />
      <Reviews />
      <Footer />
    </div>
  )
}

export default Client
